import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {CompetitorPlayersStatsModulePlayerChangeHandler} from "./competitor-players-stats-module.player-change.handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {CompetitorPlayerStatsModuleStatsScrolledEventHandler} from "./analytics/competitor-player-stats-module.stats-scrolled.event-handler";
import {CompetitorPlayerStatsModuleStatsDisplayEventHandler} from "./analytics/competitor-player-stats-module.stats-display.event-handler";
import {CompetitorPlayerStatsModuleStatsPlayerScrollEventHandler} from "./analytics/competitor-player-stats-module.stats-player-scroll.event-handler";
import {CompetitorPlayersStatsModuleAthleteLineupFetchHandler} from "./competitor-players-stats-module.athlete-lineup.fetch-handler";
import {CompetitorPlayersStatsModuleFetchHandler} from "./competitor-players-stats-module.fetch-handler";
import {CompetitorPlayerStatsModuleButtonClickEventHandler} from "./analytics/competitor-player-stats-module.button-click.event-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {MatchDetailsClickEventHandler} from "../../../core/handlers/match-details.click-event.handler";
import {CompetitorPlayersStatsModuleTabChangeEventHandler} from "./competitor-players-stats-module.tab-change.event-handler";
import {CompetitorPlayerStatsModuleShotSelectedHandler} from "./competitor-player-stats-module.shot-selected.handler";
import {CompetitorPlayerStatsModuleGoalViewHandler} from "./competitor-player-stats-module.goal-view.handler";
import {CompetitorPlayerStatsModuleShotMapShotClickEventHandler} from "./analytics/competitor-player-stats.module.shot-map.shot-click.event.handler";
import {CompetitorPlayerStatsModuleShotMapShowMoreClickEventHandler} from "./analytics/competitor-player-stats.module.shot-map.show-more-click.event.handler";
import {CompetitorPlayerStatsModuleTabClickEventHandler} from "./analytics/competitor-player-stats.module.tab-click.event.handler";
import {CompetitorPlayerStatsModuleShotMapShotSwipeClickEventHandler} from "./analytics/competitor-player-stats.module.shot-map.shot-swipe-click.event.handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";

export class CompetitorPlayersStatsModuleHandlers extends HandlerList {

  static injectables = [
    CompetitorPlayersStatsModuleFetchHandler,
    CompetitorPlayersStatsModulePlayerChangeHandler,
    CompetitorPlayerStatsModuleStatsScrolledEventHandler,
    CompetitorPlayerStatsModuleStatsDisplayEventHandler,
    CompetitorPlayerStatsModuleStatsPlayerScrollEventHandler,
    CompetitorPlayersStatsModuleAthleteLineupFetchHandler,
    CompetitorPlayerStatsModuleButtonClickEventHandler,
    CompetitorPlayersStatsModuleTabChangeEventHandler,
    CompetitorPlayerStatsModuleShotSelectedHandler,
    CompetitorPlayerStatsModuleGoalViewHandler,
    CompetitorPlayerStatsModuleShotMapShotClickEventHandler,
    CompetitorPlayerStatsModuleShotMapShowMoreClickEventHandler,
    CompetitorPlayerStatsModuleTabClickEventHandler,
    CompetitorPlayerStatsModuleShotMapShotSwipeClickEventHandler,
    MatchDetailsClickEventHandler,
    EntityClickEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    competitorPlayersStatsModuleFetchHandler: CompetitorPlayersStatsModuleFetchHandler,
    competitorPlayersStatsModulePlayerChangeHandler: CompetitorPlayersStatsModulePlayerChangeHandler,
    competitorPlayerStatsModuleStatsScrolledEventHandler: CompetitorPlayerStatsModuleStatsScrolledEventHandler,
    competitorPlayerStatsModuleStatsDisplayEventHandler: CompetitorPlayerStatsModuleStatsDisplayEventHandler,
    competitorPlayerStatsModuleStatsPlayerScrollEventHandler: CompetitorPlayerStatsModuleStatsPlayerScrollEventHandler,
    competitorPlayersStatsModuleAthleteLineupFetchHandler: CompetitorPlayersStatsModuleAthleteLineupFetchHandler,
    competitorPlayerStatsModuleButtonClickEventHandler: CompetitorPlayerStatsModuleButtonClickEventHandler,
    competitorPlayersStatsModuleTabChangeEventHandler: CompetitorPlayersStatsModuleTabChangeEventHandler,
    competitorPlayerStatsModuleShotSelectedHandler: CompetitorPlayerStatsModuleShotSelectedHandler,
    competitorPlayerStatsModuleGoalViewHandler: CompetitorPlayerStatsModuleGoalViewHandler,
    competitorPlayerStatsModuleShotMapDisplayEventHandler: CompetitorPlayerStatsModuleShotMapShotClickEventHandler,
    competitorPlayerStatsModuleShotMapShowMoreClickEventHandler: CompetitorPlayerStatsModuleShotMapShowMoreClickEventHandler,
    competitorPlayerStatsModuleTabClickEventHandler: CompetitorPlayerStatsModuleTabClickEventHandler,
    competitorPlayerStatsModuleShotMapShotSwipeClickEventHandler: CompetitorPlayerStatsModuleShotMapShotSwipeClickEventHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      competitorPlayersStatsModuleFetchHandler,
      competitorPlayersStatsModulePlayerChangeHandler,
      competitorPlayerStatsModuleStatsScrolledEventHandler,
      competitorPlayerStatsModuleStatsDisplayEventHandler,
      competitorPlayerStatsModuleStatsPlayerScrollEventHandler,
      competitorPlayersStatsModuleAthleteLineupFetchHandler,
      competitorPlayerStatsModuleButtonClickEventHandler,
      competitorPlayersStatsModuleTabChangeEventHandler,
      competitorPlayerStatsModuleShotSelectedHandler,
      competitorPlayerStatsModuleGoalViewHandler,
      competitorPlayerStatsModuleShotMapDisplayEventHandler,
      competitorPlayerStatsModuleShotMapShowMoreClickEventHandler,
      competitorPlayerStatsModuleTabClickEventHandler,
      competitorPlayerStatsModuleShotMapShotSwipeClickEventHandler,
      matchDetailsClickEventHandler,
      entityClickEventHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
